export default {
    data() {
        return {
            value:""
        }
    },
    mounted: function () {
        
    },
    methods: {

    }
}